import React from "react";
import './misionVision.css';

export default function MisionVision() {
  return (
    <>
      <h2 className="text-center mb-5">Nuestra Esencia</h2>
      <div className="row g-4">
        {/* Slogan */}
        <div className="col-md-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-soundwave fs-1 text-primary mb-3"></i>
              <h3 className="h4">Slogan</h3>
              <p className="text-muted">
                🎵 <strong>"Donde el sonido se convierte en leyenda."</strong> -  
                <strong>Vintage Pro Audio</strong> tu aliado en el mundo del audio profesional.
              </p>
            </div>
          </div>
        </div>

        {/* Misión */}
        <div className="col-md-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-bullseye fs-1 text-primary mb-3"></i>
              <h3 className="h4">Nuestra Misión</h3>
              <p className="text-muted">
                Brindar soluciones de audio profesional de la más alta calidad,
                ofreciendo equipos de marcas líderes, asesoría experta y un
                servicio excepcional para músicos, productores y amantes del
                sonido en Colombia.
              </p>
            </div>
          </div>
        </div>

        {/* Visión */}
        <div className="col-md-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body text-center">
              <i className="bi bi-eye fs-1 text-primary mb-3"></i>
              <h3 className="h4">Nuestra Visión</h3>
              <p className="text-muted">
                Ser la empresa de referencia en el mercado colombiano de audio
                profesional, reconocida por la excelencia, la innovación y la
                pasión por el sonido.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
